import { useTranslation } from '@pulsex/localization'
import { BlockIcon, CheckmarkCircleIcon, Flex, Link, RefreshIcon } from '@pulsex/uikit'
import { ChainLogo } from '@pulsex/widgets-internal'
import { styled } from 'styled-components'
import { TransactionDetails } from 'state/transactions/reducer'
import { TransactionType } from 'state/transactions/actions'
import { getBlockExplorerLink } from 'utils'

interface TransactionRowProps {
  txn: TransactionDetails
  chainId: number
  type?: TransactionType
  onDismiss: () => void
}

const TxnIcon = styled(Flex)`
  align-items: center;
  flex: none;
  width: 24px;
`

const Summary = styled.div`
  flex: 1;
  padding: 0 8px;
`

const TxnLink = styled(Link)`
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  margin-bottom: 16px;
  width: 100%;

  &:hover {
    text-decoration: none;
  }
`

const renderIcon = (txn: TransactionDetails) => {
  if (!txn.receipt) {
    return <RefreshIcon spin width="24px" />
  }

  return txn.receipt?.status === 1 || typeof txn.receipt?.status === 'undefined' ? (
    <CheckmarkCircleIcon color="success" width="24px" />
  ) : (
    <BlockIcon color="failure" width="24px" />
  )
}

const TransactionRow: React.FC<React.PropsWithChildren<TransactionRowProps>> = ({ txn, chainId }) => {
  const { t } = useTranslation()

  if (!txn) {
    return null
  }

  return (
    <TxnLink target="_blank" rel="noopener noreferrer" to={getBlockExplorerLink(txn.hash, 'transaction', chainId)}>
      <TxnIcon>{renderIcon(txn)}</TxnIcon>
      <Summary>
        {txn.translatableSummary
          ? t(txn.translatableSummary.text, txn.translatableSummary.data)
          : txn.summary ?? txn.hash}
      </Summary>
      <TxnIcon>
        <ChainLogo chainId={chainId}/>
      </TxnIcon>
    </TxnLink>
  )
}

export default TransactionRow
